import { MainContent } from "./MainContent";
import { ErrorBoundary } from "react-error-boundary";
import { ApplicationErrorBoundary } from "./components/errorboundary/ApplicationErrorBoundary";
import { useTranslation } from "react-i18next";

function ErrorFallback() {
  return <ApplicationErrorBoundary />;
}

export const Main: React.FC = () => {

  const { t, i18n } = useTranslation();

  return (

    <ErrorBoundary FallbackComponent={ErrorFallback}>


      {/* <h2>Language: {i18n.language}</h2>
      <p>{t("errorboundary.message")}</p> */}

      <MainContent />

    </ErrorBoundary>
  );

  // TODO: Display loading indicator
  //  return null;
};
